// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3265":"bf5081ca","6923":"bf5081ca","7201":"44d7851f","9322":"f8be5851"}[chunkId] + ".chunk.css";
};